import type { PortalUploadModel } from '@/hooks/finance/usePortalUploadModel';
import { receivingOfficePhrase } from '../reports/receivingOffice';

type ReportedNoteModel = Pick<
  PortalUploadModel,
  'isPortalUpload' | 'stateDisplayName' | 'portalName' | 'filingTransport'
>;

/**
 * §33 — a row reads Reported only once a committing filing action stamps it (#1007): the in-system
 * file, mark-filed, or a portal upload confirmation. So "Reported" means on file, and where filing
 * happens outside the app (a portal upload, or an email to the receiving office) the note names
 * where it went. Omitted where there is no nameable destination.
 */
export function reportedOnFileNote(model: ReportedNoteModel): string | undefined {
  if (!model.isPortalUpload || !model.stateDisplayName) return undefined;
  const route =
    model.filingTransport === 'email'
      ? `emailed to ${receivingOfficePhrase(model.portalName)}`
      : `uploaded to the ${model.stateDisplayName} ${model.portalName}`;
  return `'Reported' = on file with the state. The report that carries it was ${route} and marked filed.`;
}
